import React, { useState, useRef, useEffect } from 'react';
import { IconGear, IconChevronDown } from 'src/presentations/components/atom/icons';
import { useAskFreya } from '../../pages/askFreya/AskFreyaContext';

export const AgentSelector: React.FC = () => {
  const { agents, selectedAgent, setSelectedAgent, isLoading } = useAskFreya();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentAgent = agents.find((a) => a.name === selectedAgent);

  if (agents.length === 0) return null;

  return (
    <div className='relative' ref={dropdownRef}>
      <button
        type='button'
        onClick={() => setIsOpen(!isOpen)}
        disabled={isLoading}
        className='flex items-center gap-8 px-12 py-6 rounded-lg border border-neutral-20 bg-white hover:bg-neutral-5 transition-colors text-14 font-medium text-neutral-80 disabled:opacity-50 disabled:cursor-not-allowed'
      >
        <IconGear size={16} />
        <span className='max-w-[180px] truncate'>{currentAgent?.title ?? 'Select agent'}</span>
        <IconChevronDown size={12} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className='absolute top-full left-0 mt-4 w-[320px] bg-white rounded-12 border border-neutral-20 shadow-lg z-50 py-4 max-h-[400px] overflow-y-auto'>
          {agents.map((agent) => (
            <button
              key={agent.name}
              type='button'
              onClick={() => {
                setSelectedAgent(agent.name);
                setIsOpen(false);
              }}
              className={`w-full text-left px-16 py-10 hover:bg-neutral-5 transition-colors ${agent.name === selectedAgent ? 'bg-[#F0FDF4]' : ''}`}
            >
              <div className='flex items-center justify-between'>
                <span className='text-14 font-medium text-neutral-80'>{agent.title}</span>
                {agent.name === selectedAgent && (
                  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#00A651' strokeWidth='2'>
                    <polyline points='20 6 9 17 4 12' />
                  </svg>
                )}
              </div>
              <p className='text-12 text-neutral-50 mt-2 line-clamp-2'>{agent.description}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
